"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = require("./Typography.types");
var _logService = require("../tools/service/log/logService");
var _Typography2 = require("./Typography.styles");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var styles = {
  "typography": "xih2fc",
  "typographyDesktop": "r4Q8xM",
  "typographyTablet": "_8JKqPG",
  "typographyMobile": "wIyEP2",
  "inline": "Bm9DLt",
  "noWrap": "fkcIZ8",
  "default": "EKXjIf",
  "lighter": "_72Hu5c",
  "disabled": "pqoPK3",
  "interaction": "_7xhw0P",
  "interactionHovered": "_2LzOpt",
  "interactionSpecial": "QzGUbv",
  "interactionSpecialHovered": "l82Dzw",
  "critical": "_2GBAMX",
  "warning": "wKsT7J",
  "positive": "d0H1B-",
  "decorative": "AdZAw0",
  "inverse": "_0S0qEC",
  "inverseLighter": "NQNYM9",
  "inverseDisabled": "PVxasD",
  "inverseOnDisabled": "GNo9iB",
  "onDisabled": "jPOWSU",
  "onDecorative": "YdV63z",
  "onSelected": "rKDukp",
  "onSelectedHovered": "_4IWWMA",
  "m": "op0W1D",
  "mt": "_4xzT4g",
  "mr": "vY26w4",
  "ml": "p4uM-0",
  "mb": "_5rXPcH",
  "mx": "_54GFVr",
  "my": "_-28zlt",
  "p": "_0r04oJ",
  "pt": "_7GYllg",
  "pr": "FLW48u",
  "pl": "_9XwKB0",
  "pb": "Gc53JM",
  "px": "N-WB6d",
  "py": "kUo91b"
};
var levelStyles = {
  "heroLarge": "mosXtW",
  "heroMedium": "_4xFzPA",
  "heroSmall": "zWHvO-",
  "display": "k-ohj4",
  "heading": "_7pZbty",
  "title": "EqjlRj",
  "bodyStrong": "A68t3o",
  "body": "Ci-jp3",
  "captionStrong": "pwAPLE",
  "caption": "_1tBHcU"
};
var levelTags = {
  heroLarge: 'h2',
  heroMedium: 'h2',
  heroSmall: 'h2',
  display: 'h3',
  heading: 'h3',
  title: 'h4',
  bodyStrong: 'p',
  body: 'p',
  captionStrong: 'small',
  caption: 'small'
};
var getTag = function getTag() {
  var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'body';
  var as = arguments.length > 1 ? arguments[1] : undefined;
  if (!as && _typeof(level) === 'object') {
    (0, _logService.logSpecificErrorMessage)('TYPOGRAPHY', "You need to pass a value to the 'as' to use responsive typography.");
    return levelTags.body;
  }
  return as || levelTags[level];
};
var Typography = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref2;
  var level = _ref.level,
    kind = _ref.kind,
    as = _ref.as,
    inline = _ref.inline,
    noWrap = _ref.noWrap,
    align = _ref.align,
    children = _ref.children,
    className = _ref.className,
    m = _ref.m,
    mt = _ref.mt,
    mr = _ref.mr,
    mb = _ref.mb,
    ml = _ref.ml,
    mx = _ref.mx,
    my = _ref.my,
    p = _ref.p,
    pt = _ref.pt,
    pr = _ref.pr,
    pb = _ref.pb,
    pl = _ref.pl,
    px = _ref.px,
    py = _ref.py,
    dataTestId = _ref['data-testid'],
    id = _ref.id,
    style = _ref.style;
  var legacyMarginProps = {
    m: m,
    mt: mt,
    mr: mr,
    mb: mb,
    ml: ml,
    mx: mx,
    my: my
  };
  var legacyPaddingProps = {
    p: p,
    pt: pt,
    pr: pr,
    pb: pb,
    pl: pl,
    px: px,
    py: py
  };
  var styleVariables = (0, _Typography2.getStyleVariables)(align, level, _objectSpread({}, _objectSpread(_objectSpread({}, legacyMarginProps), legacyPaddingProps)));
  var builtClassNames = (0, _clsx["default"])('CozyTypography', className, styles.typography, noWrap && styles.noWrap, inline && styles.inline, kind && styles[kind], _typeof(level) !== 'object' ? levelStyles[level] : (_ref2 = {}, _defineProperty(_ref2, styles.typographyMobile, level.mobile !== undefined), _defineProperty(_ref2, styles.typographyTablet, level.tablet !== undefined), _defineProperty(_ref2, styles.typographyDesktop, level.desktop !== undefined), _ref2), p && styles.p, pt && styles.pt, pr && styles.pr, pl && styles.pl, pb && styles.pb, px && styles.px, py && styles.py, m && styles.m, mt && styles.mt, mr && styles.mr, ml && styles.ml, mb && styles.mb, mx && styles.mx, my && styles.my);
  var Tag = getTag(level, as);
  return /*#__PURE__*/_react["default"].createElement(Tag, {
    ref: ref,
    "data-testid": dataTestId,
    id: id,
    style: _objectSpread(_objectSpread({}, styleVariables), style),
    className: builtClassNames
  }, children);
});
Typography.propTypes = process.env.NODE_ENV !== "production" ? {
  level: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(Object.values(_Typography.Level)), _propTypes["default"].shape({
    mobile: _propTypes["default"].oneOf(Object.values(_Typography.Level)),
    tablet: _propTypes["default"].oneOf(Object.values(_Typography.Level)),
    desktop: _propTypes["default"].oneOf(Object.values(_Typography.Level))
  })]),
  kind: _propTypes["default"].oneOf(Object.values(_Typography.Kind)),
  as: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].elementType]),
  inline: _propTypes["default"].bool,
  noWrap: _propTypes["default"].bool,
  align: _propTypes["default"].string,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  'data-testid': _propTypes["default"].string,
  // TODO - legacy props exceptionally for rebranding v1
  id: _propTypes["default"].string,
  style: _propTypes["default"].object,
  m: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  mt: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  mr: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  mb: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  ml: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  mx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  my: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  p: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  pt: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  pr: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  pb: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  pl: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  px: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  py: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
} : {};
Typography.defaultProps = {
  level: _Typography.Level.BODY,
  inline: false,
  noWrap: false
};
Typography.displayName = 'Typography';
var _default = exports["default"] = Typography;